// extracted by mini-css-extract-plugin
module.exports = {"button":"vEf4KtuWvkzsRO1m4ICb","disabled":"ZKofno9UGcdtCZQVOPGt","secret":"DlzzCDlqU3lOjpvGPaxl"};